import React from 'react';
import PropTypes from 'prop-types';

const EffectArrowPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M21.765 9h-7.71a1.5 1.5 0 1 1 0-3H25.17a1.5 1.5 0 0 1 1.5 1.5v11.331a1.5 1.5 0 0 1-3 0V11.34L8.56 26.447a1.5 1.5 0 0 1-2.122-2.121L21.765 9z"
    />
  );
};

EffectArrowPath.propTypes = {
  fill: PropTypes.string,
};

export default EffectArrowPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/effects/effect-arrow.jsx